'use strict';

exports.__esModule = true;
exports.RemoteGlobalsInterface = undefined;

var _urlUtils = require('./urlUtils');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RemoteGlobalsInterface = function () {
  function RemoteGlobalsInterface(modelJson) {
    _classCallCheck(this, RemoteGlobalsInterface);

    this._globals = _lodash2.default.defaults(modelJson, {
      navigation: {},
      sessionInfo: {},
      appsData: {},
      siteMemberData: { uid: null, permissions: null, onUserLogin: [] },
      multilingualInfo: { isEnabled: false, currentLanguageCode: null, siteLanguages: [], onCurrentLanguageChange: [] },
      appStudioWidgetData: { isApplicationStudio: false, onPropsChanged: [] },
      deviceType: null,
      isMobileFriendly: null,
      lightboxContext: undefined,
      contextId: null,
      siteRevision: null,
      routerData: null,
      regionalSettings: {
        locale: null,
        language: null,
        timezone: null,
        currency: null,
        browserLocale: null
      },
      seo: {
        isInSEO: undefined
      }
    });
    this._globals.onInstanceChanged = {}; //{appDefId: [callback, callback, ...],
    this._globals.onLocationChange = [];
  }

  RemoteGlobalsInterface.prototype.addRegionalSettings = function addRegionalSettings(regionalSettings) {
    this._globals.regionalSettings = regionalSettings;
  };

  RemoteGlobalsInterface.prototype.addNavigation = function addNavigation(navigationData) {
    var _this = this;

    this._globals.navigation = navigationData;
    var onLocationChangeCallbacks = this._globals.onLocationChange;
    _lodash2.default.forEach(onLocationChangeCallbacks, function (callback) {
      return callback({ path: _this.getLocation().path });
    });
  };

  RemoteGlobalsInterface.prototype.addSiteMemberData = function addSiteMemberData(siteMemberData) {
    var shouldTriggerOnLoginCallback = siteMemberData.uid && siteMemberData.uid !== this._globals.siteMemberData.uid;
    _lodash2.default.assign(this._globals.siteMemberData, siteMemberData);
    if (shouldTriggerOnLoginCallback) {
      var onUserLoginCallbacks = this._globals.siteMemberData.onUserLogin;
      _lodash2.default.forEach(onUserLoginCallbacks, function (callback) {
        callback(siteMemberData);
      });
    }
  };

  RemoteGlobalsInterface.prototype.addAppsData = function addAppsData(newAppsData) {
    var oldAppsData = this._globals.appsData;
    _lodash2.default.forEach(this._globals.onInstanceChanged, function (callbacks, appDefinitionId) {
      var oldInstance = _lodash2.default.get(oldAppsData, [appDefinitionId, 'instance']);
      var newInstance = _lodash2.default.get(newAppsData, [appDefinitionId, 'instance']);
      if (oldInstance !== newInstance) {
        _lodash2.default.invokeMap(callbacks, 'call', null, { instance: newInstance });
      }
    });
    this._globals.appsData = newAppsData;
  };

  RemoteGlobalsInterface.prototype.addOnLocationChangeCallback = function addOnLocationChangeCallback(callback) {
    if (!this._globals.onLocationChange) {
      this._globals.onLocationChange = [];
    }
    this._globals.onLocationChange.push(callback);
  };

  RemoteGlobalsInterface.prototype.addOnUserLoginCallback = function addOnUserLoginCallback(callback) {
    this._globals.siteMemberData.onUserLogin.push(callback);
  };

  RemoteGlobalsInterface.prototype.addSessionInfoProp = function addSessionInfoProp(_addSessionInfoProp) {
    _lodash2.default.assign(this._globals.sessionInfo, _addSessionInfoProp);
  };

  RemoteGlobalsInterface.prototype.addSiteRevision = function addSiteRevision(siteRevision) {
    this._globals.siteRevision = siteRevision;
  };

  RemoteGlobalsInterface.prototype.addDeviceType = function addDeviceType(deviceType) {
    this._globals.deviceType = deviceType;
  };

  RemoteGlobalsInterface.prototype.addIsMobileFriendly = function addIsMobileFriendly(isMobileFriendly) {
    this._globals.isMobileFriendly = isMobileFriendly;
  };

  RemoteGlobalsInterface.prototype.addLightboxContext = function addLightboxContext(lightboxContext) {
    this._globals.lightboxContext = lightboxContext;
  };

  RemoteGlobalsInterface.prototype.addContextId = function addContextId(contextId) {
    this._globals.contextId = contextId;
  };

  RemoteGlobalsInterface.prototype.addMultilingualInfo = function addMultilingualInfo(multilingualInfo) {
    var shouldTriggerOnCurrentLanguageChange = multilingualInfo.currentLanguageCode && multilingualInfo.currentLanguageCode !== this._globals.multilingualInfo.currentLanguageCode;

    _lodash2.default.assign(this._globals.multilingualInfo, multilingualInfo);
    if (shouldTriggerOnCurrentLanguageChange) {
      var onCurrentLanguageChangeCallbacks = this._globals.multilingualInfo.onCurrentLanguageChange;
      _lodash2.default.forEach(onCurrentLanguageChangeCallbacks, function (callback) {
        callback(multilingualInfo);
      });
    }
  };

  RemoteGlobalsInterface.prototype.addOnCurrentLanguageChangeCallback = function addOnCurrentLanguageChangeCallback(callback) {
    this._globals.multilingualInfo.onCurrentLanguageChange.push(callback);
  };

  RemoteGlobalsInterface.prototype.addLivePreviewMode = function addLivePreviewMode(livePreviewMode) {
    this._globals.livePreviewMode = livePreviewMode;
  };

  RemoteGlobalsInterface.prototype.addRouterData = function addRouterData(routerData) {
    this._globals.routerData = routerData;
  };

  //Getters

  RemoteGlobalsInterface.prototype.getRouterData = function getRouterData(appDefinitionId) {

    var isAppRouterData = function isAppRouterData() {
      var isUserCode = _lodash2.default.isUndefined(appDefinitionId);
      var isWixCodeRouter = routerAppDefId === 'wix-code';
      var isAppRouter = appDefinitionId === routerAppDefId;
      return isWixCodeRouter && isUserCode || isAppRouter;
    };
    if (!this._globals.routerData) {
      return null;
    }
    var routerAppDefId = _lodash2.default.get(this._globals.routerData, 'routerDefinition.appDefinitionId');

    return isAppRouterData() ? _lodash2.default.cloneDeep(this._globals.routerData.routerData) : null;
  };

  RemoteGlobalsInterface.prototype.getAppsData = function getAppsData() {
    return _lodash2.default.cloneDeep(this._globals.appsData);
  };

  RemoteGlobalsInterface.prototype.getDeviceType = function getDeviceType() {
    return this._globals.deviceType;
  };

  RemoteGlobalsInterface.prototype.getIsMobileFriendly = function getIsMobileFriendly() {
    return this._globals.isMobileFriendly;
  };

  RemoteGlobalsInterface.prototype.getLightboxContext = function getLightboxContext() {
    return _lodash2.default.cloneDeep(this._globals.lightboxContext);
  };

  RemoteGlobalsInterface.prototype.getContextId = function getContextId() {
    return this._globals.contextId;
  };

  //Getters

  RemoteGlobalsInterface.prototype.getAppData = function getAppData(appDefinitionId) {
    return _lodash2.default.cloneDeep(_lodash2.default.get(this._globals.appsData, appDefinitionId));
  };

  RemoteGlobalsInterface.prototype.getNavigationInfo = function getNavigationInfo() {
    return _lodash2.default.cloneDeep(this._globals.navigation);
  };

  RemoteGlobalsInterface.prototype.getRegionalSettings = function getRegionalSettings() {
    return _lodash2.default.cloneDeep(this._globals.regionalSettings);
  };

  RemoteGlobalsInterface.prototype.getSiteMemberData = function getSiteMemberData(appDefinitionId) {
    var siteMemberData = _lodash2.default.cloneDeep(this._globals.siteMemberData);
    if (appDefinitionId) {
      var appData = _lodash2.default.get(this._globals.appsData, appDefinitionId);
      if (appData) {
        _lodash2.default.assign(siteMemberData, _lodash2.default.pick(appData, ['instance', 'instanceId']));
      }
    }
    return siteMemberData;
  };

  RemoteGlobalsInterface.prototype.getMultilingualInfo = function getMultilingualInfo() {
    return _lodash2.default.cloneDeep(this._globals.multilingualInfo);
  };

  RemoteGlobalsInterface.prototype.getCurrentLanguageCode = function getCurrentLanguageCode() {
    return this._globals.multilingualInfo.currentLanguageCode;
  };

  RemoteGlobalsInterface.prototype.getSiteLanguages = function getSiteLanguages() {
    return this._globals.multilingualInfo.siteLanguages;
  };

  RemoteGlobalsInterface.prototype.getIsMultilingualEnabled = function getIsMultilingualEnabled() {
    return this._globals.multilingualInfo.isEnabled;
  };

  RemoteGlobalsInterface.prototype.getSessionInfo = function getSessionInfo() {
    return _lodash2.default.cloneDeep(this._globals.sessionInfo);
  };

  RemoteGlobalsInterface.prototype.getLivePreviewMode = function getLivePreviewMode() {
    return this._globals.livePreviewMode;
  };

  RemoteGlobalsInterface.prototype.addIsApplicationStudio = function addIsApplicationStudio(isApplicationStudio) {
    this._globals.appStudioWidgetData.isApplicationStudio = isApplicationStudio;
  };

  RemoteGlobalsInterface.prototype.getIsApplicationStudio = function getIsApplicationStudio() {
    return this._globals.appStudioWidgetData.isApplicationStudio;
  };

  RemoteGlobalsInterface.prototype.getSiteRevision = function getSiteRevision() {
    return _lodash2.default.invoke(this._globals.siteRevision, 'toString') || null;
  };

  RemoteGlobalsInterface.prototype.addOnWidgetPropsChangedCallback = function addOnWidgetPropsChangedCallback(callback) {
    this._globals.appStudioWidgetData.onPropsChanged.push(callback);
  };

  RemoteGlobalsInterface.prototype.triggerWidgetPropsChanged = function triggerWidgetPropsChanged(oldProps, newProps) {
    _lodash2.default.forEach(this._globals.appStudioWidgetData.onPropsChanged, function (callback) {
      callback(_lodash2.default.cloneDeep(oldProps), _lodash2.default.cloneDeep(newProps));
    });
  };

  RemoteGlobalsInterface.prototype.addOnInstanceChangedCallback = function addOnInstanceChangedCallback(appDefinitionId, callback) {
    if (!this._globals.onInstanceChanged[appDefinitionId]) {
      this._globals.onInstanceChanged[appDefinitionId] = [];
    }
    this._globals.onInstanceChanged[appDefinitionId].push(callback);
  };

  RemoteGlobalsInterface.prototype.getFullUrl = function getFullUrl() {
    return this._globals.navigation.currentPageFullUrl || this._globals.navigation.baseUrl;
  };

  RemoteGlobalsInterface.prototype.getLocation = function getLocation() {
    var location = {};
    location.url = this.getFullUrl();

    var parsedUrl = (0, _urlUtils.parseUrl)(location.url);
    var prefix = this._globals.navigation && this._globals.navigation.routerDefinition ? this._globals.navigation.routerDefinition.prefix : undefined;
    var isFreeSite = this._globals.navigation.baseUrl.indexOf('wixsite.com') > 0;
    var pathAsArray = parsedUrl.path.substring(1).split('/');
    var fullPath = isFreeSite ? pathAsArray.slice(1) : pathAsArray;

    location.hash = parsedUrl.hash;
    location.protocol = parsedUrl.protocol;
    location.prefix = prefix;
    location.path = prefix && fullPath[0] === prefix ? fullPath.slice(1) : fullPath;
    location.query = parsedUrl.query;

    return location;
  };

  RemoteGlobalsInterface.prototype.isInSEO = function isInSEO() {
    return this._globals.seo.isInSEO;
  };

  RemoteGlobalsInterface.prototype.toJson = function toJson() {
    return this._globals;
  };

  return RemoteGlobalsInterface;
}();

exports.RemoteGlobalsInterface = RemoteGlobalsInterface;
//# sourceMappingURL=RemoteGlobalsInterface.js.map